import { get } from "@/utils/request"; // 导入模块

// 职位详情
export const getJobDetail = (params) =>
    get("Api/JobDetail/GetJobDetail", params);

// 企业详情
export const getClientList = (params) =>
    get("Api/JobDetail/GetJobDetailClientDetail", params);

// 相似职位
export const getSimilarJobList = (params) =>
    get("Api/JobDetail/GetJobDetailJobList", params);







// // 职位详情
// export const getJobDetail = (params) =>
//     get("api/Api/JobDetail/GetJobDetail", params);

// // 企业详情
// export const getClientList = (params) =>
//     get("api/Api/JobDetail/GetJobDetailClientDetail", params);

// // 相似职位
// export const getSimilarJobList = (params) =>
//     get("api/Api/JobDetail/GetJobDetailJobList", params);
